import { _js } from '@ifixit/localize';
import { StatusNotice } from 'Shared/status_notice';

onDomReady(() => {
   when($('revertButton'), button => {
      button.addEvent('click', () => {
         if (confirm(_js('Are you sure you want to revert this revision?'))) {
            new Request.API_2_0(App.revertUrl, {
               method: 'POST',
               statusPanelMessage: _js('Reverting...'),
               onSuccess: function (response) {
                  window.location = App.redirectUrl;
               },
            }).send();
         }
      });
   });
});
